import { render, staticRenderFns } from "./achievement.vue?vue&type=template&id=07cb6c28&scoped=true&"
import script from "./achievement.vue?vue&type=script&lang=js&"
export * from "./achievement.vue?vue&type=script&lang=js&"
import style0 from "./achievement.vue?vue&type=style&index=0&id=07cb6c28&lang=scss&scoped=true&"
import style1 from "./achievement.vue?vue&type=style&index=1&id=07cb6c28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cb6c28",
  null
  
)

export default component.exports